import { useContext } from 'react'

import { BenefitModalContext } from './BenefitModalContext'

export const useBenefitModals = () => {
  const context = useContext(BenefitModalContext)

  if (context === undefined) {
    throw new Error('useBenefitModals must be used within a BenefitModalProvider')
  }

  return context
}
